export const subadminsKey = "subadmins";
export const subadminRolesKey = "subadminRoles";
export const staffKey = "staff";
export const staffRolesKey = "staffRoles";
export const settingsKey = "settings";
export const informationPolicyKey = "informationPolicy";
export const categoryQuestionsKey = "categoryQuestions";
export const cartKey = "cart";
export const productsKey = "products";
export const categoriesKey = "categories";
export const brandsKey = "brands";
export const pagesKey = "Pages";
export const bannerKey = "banners";
export const bookingsKey = "bookings";
export const paymentsKey = "payments";
export const widgetsKey = "widgets";
export const adminSettingsKey = "adminSettings";
export const clientsKey = "clients";
export const seoKey = "seo";
export const configSettingsKey = "configSettings";
export const templateKey = "template";
export const reviewUrlKey = "reviewUrl";
export const feedbackTypesKey = "feedbackTypes";
export const issueKey = "issues";
export const visitLocationKey = "visitLocations";
export const inboxKey = "inbox";
export const trendsKey = "departmentTrends";
export const couponsKey = "coupons";
export const visitorType = "visitorType";
export const locationKey = "location";
export const cancellationRequest = "cancellation";
export const listingKey = "listings";
export const districtKey = "district";
export const stateKey = "state";
export const countryKey = "country";
export const pincodeKey = "pincode";
export const cityKey = "city";
export const brandKey = "brand";
export const categoryKey = "category";
export const userKey = "user";
export const ratingKey = "rating";
export const googleReviewsKey = "googleReviews";
export const notificationKey = "notificationKey";
export const deliveryZoneKey = "delivery-zones";
export const ordersKey = "orders";
export const returnKey = "return";
